// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5040":"76ac6228bae48b55","7650":"a5cf04fb924f7317"}[chunkId] + ".css";
};